module.exports = __webpack_public_path__ + "static/media/croissant.27834aef.svg";